import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { BrandService } from '../../_ecomservices/brand.service';
import * as _ from 'lodash';
import { BrandsComponent } from '../brands/brands.component';

@Component({
  selector: 'app-brand-edit',
  templateUrl: './brand-edit.component.html',
  styleUrls: ['./brand-edit.component.css']
})
export class BrandEditComponent implements OnInit {

  brand_img: File = null;
  brandList:any = [];
  brandImagePreview: string | ArrayBuffer | null = null;

  brand_edit_form = new FormGroup({
    id : new FormControl(null),
    brand_name : new FormControl('', [Validators.required]),
    slug : new FormControl(''),
    brand_desc : new FormControl(''),
    brand_img : new FormControl(null),
  });

  constructor(private dialogRef: MatDialogRef<BrandsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private loading : LoadingService,
    private notificationService: NotificationService,
    private brandService: BrandService,
  ) { 
    this.onLoadBrands();
    this.onloadBrandDetails(data.brandId);
  }

  ngOnInit() {
    
  }

  onLoadBrands() {
    var result = this.brandService.get_brands().subscribe(data=> {
      this.brandList = data['brandList'];
    });
  }

  onloadBrandDetails(brand_id)
  {
    this.brandService.get_brand_id(brand_id).subscribe(data=> {
      this.brand_edit_form.setValue(_.omit(data['brand_data'], 'status', 'created_at', 'updated_at', 'deleted_at'));
      this.brandImagePreview = data['brand_data']['brand_img'];
      this.loading.spin$.next(false);
    });
  }
  

  onSelectBrandImageFile(event: any): void {
    const file = event.target.files[0];
    if (file) 
    {
      this.brand_img = file;
      // this.brand_edit_form.patchValue({ brand_img: file });      
      //this.brand_edit_form.get('brand_img')!.updateValueAndValidity();
      // Image Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.brandImagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }


  onUpdateBrandFormSubmit(formData: any)
  {
    if (this.brand_edit_form.valid){
       //this.loading.spin$.next(true);
        this.brandService.update_brand(formData, this.brand_img).subscribe(data=>{
          console.log(data);
          if (data['status']) 
          {
            this.notificationService.success('Brand data updated Successfully.');
            this.onClose(data);
            this.loading.spin$.next(false);
          } 
          else 
          {
            this.notificationService.error(data['error_message']);
            this.loading.spin$.next(false);
          }
        });
      } 
  }

  onClose(data)
  {
    this.brand_edit_form.reset();
    this.dialogRef.close(data);  
  }

}
